import { useState } from "react";
import wordmarkSvg from "@/assets/wordmark.svg";
import logoSvg from "@/assets/logo.svg";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import GetStartedButton from "@/components/landing/GetStartedButton";
import { motion, AnimatePresence } from "framer-motion";

const navLinks: { label: string; href: string }[] = [];

const LandingNav = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const scrollTo = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    el?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[hsl(230,60%,6%)]/70 backdrop-blur-xl border-b border-white/5">
      <div className="container mx-auto flex items-center justify-between py-4 px-6">
        <Link to="/" className="flex items-center gap-2">
          <img src={logoSvg} alt="" className="h-7 w-7 rounded-lg" />
          <img src={wordmarkSvg} alt="HeirWise wordmark" className="h-5" />
        </Link>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => scrollTo(link.href)}
              className="px-3 py-1.5 text-sm text-white/65 hover:text-white transition-colors rounded-md"
            >
              {link.label}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <Button variant="nav" size="sm" asChild className="hidden md:inline-flex">
            <Link to="/login">Sign In</Link>
          </Button>
          <GetStartedButton variant="hero" size="sm" className="hidden md:inline-flex" />
          <button
            className="md:hidden text-white/75 hover:text-white"
            aria-label={mobileOpen ? "Close menu" : "Open menu"}
            aria-expanded={mobileOpen}
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <AnimatePresence>
        {mobileOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-[hsl(230,60%,6%)]/95 backdrop-blur-xl border-t border-white/10 overflow-hidden"
          >
            <div className="container mx-auto px-6 py-4 flex flex-col gap-2">
              {navLinks.map((link) => (
                <button
                  key={link.href}
                  onClick={() => scrollTo(link.href)}
                  className="text-left px-3 py-2 text-sm text-white/75 hover:text-white"
                >
                  {link.label}
                </button>
              ))}
              <div className="flex gap-3 pt-2">
                <Button variant="nav" size="sm" asChild>
                  <Link to="/login">Sign In</Link>
                </Button>
                <GetStartedButton variant="hero" size="sm" />
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default LandingNav;
